// redux/actions/CONCILIACION/types.js
export const FETCH_CONCILIACION_SUCCESS = "FETCH_CONCILIACION_SUCCESS";
export const FETCH_CONCILIACION_FAILURE = "FETCH_CONCILIACION_FAILURE";
export const FETCH_CONCILIACION_DOCUMENTO_SUCCESS = "FETCH_CONCILIACION_DOCUMENTO_SUCCESS";
export const FETCH_CONCILIACION_DOCUMENTO_FAILURE = "FETCH_CONCILIACION_DOCUMENTO_FAILURE";
export const FETCH_CONCILIACION_DETALLES_SUCCESS = "FETCH_CONCILIACION_DETALLES_SUCCESS";
export const FETCH_CONCILIACION_DETALLES_FAILURE = "FETCH_CONCILIACION_DETALLES_FAILURE";
export const FETCH_CONCILIACION_AUDIENCIAS_SUCCESS = "FETCH_CONCILIACION_AUDIENCIAS_SUCCESS";
export const FETCH_CONCILIACION_AUDIENCIAS_FAILURE = "FETCH_CONCILIACION_AUDIENCIAS_FAILURE";
export const FETCH_CONCILIACION_HISTORIAL_SUCCESS = "FETCH_CONCILIACION_HISTORIAL_SUCCESS";
export const FETCH_CONCILIACION_HISTORIAL_FAILURE = "FETCH_CONCILIACION_HISTORIAL_FAILURE";
export const FETCH_AUDIT_LOG_SUCCESS = "FETCH_AUDIT_LOG_SUCCESS";
export const FETCH_AUDIT_LOG_FAILURE = "FETCH_AUDIT_LOG_FAILURE";
export const FETCH_AUDIT_LOG_ONE_SUCCESS = "FETCH_AUDIT_LOG_ONE_SUCCESS";
export const FETCH_AUDIT_LOG_ONE_FAILURE = "FETCH_AUDIT_LOG_ONE_FAILURE";
